import { dataTextFlowerSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextFlowerSquareSolid = /*#__PURE__*/createIcon(dataTextFlowerSquareSolid)
export default IconTextFlowerSquareSolid
